import { useTranslation } from 'react-i18next';
import { Grid } from '@treatwell/treatwell-aura';
import { BusinessName, City, Country, PostalCode, Street } from './input';
import { Form, Prompt, Title } from './templates';

export function StepOneForm() {
  const { t } = useTranslation('stepOneForm');

  return (
    <Form>
      <Title text={t('title')} showStepCounter />
      <Prompt text={t('prompt1')} />
      <Grid>
        <div className="col-sm-12">
          <BusinessName />
        </div>
        <div className="col-sm-12">
          <Street />
        </div>
        <div className="col-sm-12">
          <City />
        </div>
        <div className="col-sm-12 col-md-6">
          <PostalCode />
        </div>
        <div className="col-sm-12 col-md-6">
          <Country />
        </div>
      </Grid>
    </Form>
  );
}
